import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocTypeOverviewAndHolderIdRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentType = control.get('documentType')!.value;
	const foreignCustomerId = control.get('foreignCustomerId')!.value;
	const coverProcessId = control.get('coverProcessId')!.value;
	const documentCategory = control.get('documentCategory')!.value;

	return (!foreignCustomerId && !coverProcessId) && documentCategory !== 'EGD02' && documentType === 'EGD029'
	              ? 	{ checkDocTypeOverviewAndHolderIdFlag: true } : null;
};
